import cardValidator from '@ott/utility-card-validator';

import { cardBinLength } from '../constants';

export const getIssuingNetworkByCardNumber = (cardNumber: string) => {
  const bin = (cardNumber || '').slice(0, cardBinLength);
  const { card: validatedCard } = cardValidator.number(bin);

  return validatedCard?.type.replace(/\W/, '') || 'default';
};
